import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LocalStorageService {
  static put(key: string, object: { [key: string]: any }): void {
    localStorage.setItem(key, JSON.stringify(object));
  }

  static get(key: string) {
    const data = localStorage.getItem(key);
    return JSON.parse(data || '{}');
  }
}
